// extracted by mini-css-extract-plugin
module.exports = {"component":"Page_component__36yZt"};